import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerItemQtyFun,
  CustomerProItemQty,
  CustomerSupplierProAcDetail,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function MontlyItemQTY({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { CustomerItemQtydata } = useSelector((state) => state.CustomerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(CustomerItemQtyFun());
    dispatch(
      CustomerProItemQty({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, Firm, YearId, accountName]);

  const getRows = CustomerItemQtydata?.Detail?.map((label, index) => ({
    chart: "true",
    // srNumber: index + 1,
    ItemName: label.ItemName,
    AprQty: label.AprQty,
    MayQty: label.MayQty,
    JunQty: label.JunQty,
    JulQty: label.JulQty,
    AugQty: label.AugQty,
    SepQty: label.SepQty,
    OctQty: label.OctQty,
    NovQty: label.NovQty,
    DecQty: label.DecQty,
    JanQty: label.JanQty,
    FebQty: label.FebQty,
    MarQty: label.MarQty,
    FinishMeter: label.FinishMeter,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Total Meter",
      key: "FinishMeter",
      align: "right",
      format: "true",
    },
    { label: "Apr ", key: "AprQty", align: "right", format: "true" },
    { label: "May ", key: "MayQty", align: "right", format: "true" },
    { label: "Jun ", key: "JunQty", align: "right", format: "true" },
    { label: "Jul ", key: "JulQty", align: "right", format: "true" },
    { label: "Aug ", key: "AugQty", align: "right", format: "true" },
    { label: "Sep ", key: "SepQty", align: "right", format: "true" },
    { label: "Oct ", key: "OctQty", align: "right", format: "true" },
    { label: "Nov ", key: "NovQty", align: "right", format: "true" },
    { label: "Dec ", key: "DecQty", align: "right", format: "true" },
    { label: "Jan ", key: "JanQty", align: "right", format: "true" },
    { label: "Feb ", key: "FebQty", align: "right", format: "true" },
    { label: "Mar ", key: "MarQty", align: "right", format: "true" },
  ];

  if (CustomerItemQtydata === "no" || CustomerItemQtydata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,

            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY ITEM QTY
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
